import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Subject, of } from 'rxjs';
import { delay, takeUntil, debounceTime } from 'rxjs/operators';

@Component({
    selector: 'my-input-number-component',
    styleUrls: ['./input-number-component.scss'],
    templateUrl: './input-number-component.html'
})
export class InputNumberComponent implements OnInit {
    @Input() step: number = 1;
    @Input() value: number = 0;
    @Input() min: number = 0;
    @Input() required: boolean = false;

    @Output() valueChange = new EventEmitter();


        // Debounce Observable to ensure multiple clicks on the up/down control does not cause the qty to miscalculate
        private qtyStepUpDebounce = new Subject<boolean>();
        private qtyStepDownDebounce = new Subject<boolean>();

    ngOnInit() {
        this.qtyStepUpDebounce.pipe(debounceTime(333)).subscribe(() => this.callStepUp());
        this.qtyStepDownDebounce.pipe(debounceTime(333)).subscribe(() => this.callStepDown());
    }

    stepUp() {
        this.qtyStepUpDebounce.next(true);
    }

    callStepUp() {

        let newValue = this.value;

        if (Number.isInteger(this.value)) {
            newValue++;
        }
        else{
            newValue = Math.ceil(this.value);
        } 

        this.change(newValue);
    }


    stepDown(){
        this.qtyStepDownDebounce.next(true);
    }

    callStepDown(){
        let newValue = this.value;

        if (this.value == 0) {
            return;;
        }
        else if (Number.isInteger(this.value)) {
            newValue--;
        }
        else{
            newValue = Math.floor(this.value);
        }
        
        this.change(newValue);
    }

 

    change(newValue) {

        this.value = newValue;
        this.valueChange.emit(newValue);
    }
}

